import { useEffect } from 'react';
import { states } from '@/constants/lifecycle';

const useFetchDatasetReports = (fetch, category, code, readStatus) => {
  useEffect(() => {
    if (readStatus === states.NONE) {
      fetch(category, code);
    }
  }, []);
};

const useFetchDictionaryReport = (fetch, category, code, readStatus, reportType, reportId) => {
  useEffect(() => {
    if (readStatus === states.NONE) {
      fetch(category, code, reportType, { id: reportId, name: reportId });
    }
  }, []);
};

const useFetchDictionaryReports = (fetch, category, code, readStatus, reportType) => {
  useEffect(() => {
    if (readStatus === states.NONE) {
      fetch(category, code, reportType);
    }
  }, []);
};

export default {
  useFetchDatasetReports,
  useFetchDictionaryReport,
  useFetchDictionaryReports,
};
